import { render, staticRenderFns } from "./location.vue?vue&type=template&id=bf434fe6&scoped=true"
import script from "./location.vue?vue&type=script&lang=js"
export * from "./location.vue?vue&type=script&lang=js"
import style0 from "./location.vue?vue&type=style&index=0&id=bf434fe6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf434fe6",
  null
  
)

export default component.exports